/*const observerW = new MutationObserver(function(mutations) {
    const klevu = document.querySelector('.kuQuickSearchResultsContainer .klevuWrap');
    const form = document.querySelector('.searchform');
    
    if (klevu && form) {
        klevu.style.setProperty('width', '100%', 'important');
        klevu.style.setProperty('max-width', form.offsetWidth + 'px', 'important');
        observerW.disconnect();
    }
});

observerW.observe(document.body, {
    childList: true,
    subtree: true
});*/

function scrollToElementByClick(e) {
  if (e.target.classList.contains('scroll-to') && e.target.hasAttribute('data-scroll-target')) {
    e.preventDefault();
    var target_selector = e.target.getAttribute('data-scroll-target');
    var target = document.querySelector(target_selector);
    var product_sticky_price_block = document.querySelector('.product-sticky-info');
    var top_offset = 10
    if (product_sticky_price_block) {
      top_offset = product_sticky_price_block.offsetHeight + 10;
    }
    if (target) {
      var target_top = target.getBoundingClientRect().top + window.scrollY - top_offset;
      window.scrollTo({
        top: target_top,
        behavior: "smooth",
      });
    }
  }
}
window.addEventListener('click',scrollToElementByClick);

function scrollToElementBySelector(target_selector) {
  if (document.querySelector(target_selector)) {
    var target = document.querySelector(target_selector);
    var product_sticky_price_block = document.querySelector('.product-sticky-info');
    var top_offset = 10
    if (product_sticky_price_block) {
      top_offset = product_sticky_price_block.offsetHeight + 10;
    }
    if (target) {
      var target_top = target.getBoundingClientRect().top + window.scrollY - top_offset;
      window.scrollTo({
        top: target_top,
        behavior: "smooth",
      });
    }
  }
}

function show_compare_on_product_card(e) {
  if (e.target.classList.contains('show-compare-input')) {
    if (e.target.checked) {
      if (e.target.closest('.shopify-section').classList.contains('hide-compare')) {
        e.target.closest('.shopify-section').classList.remove('hide-compare');
        e.target.closest('body').querySelector('.klevu-compare-widget').style.display = 'unset';       
      }
    } else {
      e.target.closest('.shopify-section').classList.add('hide-compare');
      e.target.closest('body').querySelector('.klevu-compare-widget').style.display = 'none';
      
    }
  }
}
document.addEventListener('change',show_compare_on_product_card);

function show_hide_filters(e) {
  if (e.target.classList.contains('show_hide_filters_btn')) {
    var show_text = e.target.getAttribute('data-show-text');
    var hide_text = e.target.getAttribute('data-hide-text');
    if (document.querySelector('.kuSearchResultsPageContainer .kuFilters')) {
      if (document.querySelector('.kuSearchResultsPageContainer .kuFilters.show_all')) {
        document.querySelector('.kuSearchResultsPageContainer .kuFilters').classList.remove('show_all');
        e.target.innerHTML = show_text;
      } else {
        document.querySelector('.kuSearchResultsPageContainer .kuFilters').classList.add('show_all');
        e.target.innerHTML = hide_text;
      }
    }
  }
  if (e.target.classList.contains('klevuSubfilter__show-all-btn')) {
    var show_text = e.target.getAttribute('data-show-text');
    var hide_text = e.target.getAttribute('data-hide-text');
    if (document.querySelector('.kuFilterBox--dimensions')) {
      if (document.querySelector('.kuFilterBox--dimensions.show-all')) {
        document.querySelector('.kuFilterBox--dimensions').classList.remove('show-all');
        e.target.innerHTML = show_text;
      } else {
        document.querySelector('.kuFilterBox--dimensions').classList.add('show-all');
        e.target.innerHTML = hide_text;
      }
    }
  }
}
window.addEventListener('click',show_hide_filters);

function show_hide_customer_help_popup(e) {
  if (e.target.classList.contains('wholesale-help__hide-btn')) {
    var help_popup_height = help_popup.getAttribute('data-height');
    var help_popup_width = help_popup.getAttribute('data-width');
    help_popup.style.height = help_popup_height + 'px';
    help_popup.style.width = help_popup_width + 'px';
    setTimeout(()=>{
      help_popup.style.height = 0;
      help_popup.style.width = 0;
    },10);
    setTimeout(()=>{
      help_popup.style.display = "none";
    },210);
  }
  if (e.target.classList.contains('wholesale-help__show-btn')) {
    help_popup.style.display = "block";
    setTimeout(()=>{
      var help_popup_height = help_popup.getAttribute('data-height');
      var help_popup_width = help_popup.getAttribute('data-width');
      help_popup.style.height = help_popup_height + 'px';
      help_popup.style.width = help_popup_width + 'px';
    },10);
  }
}
window.addEventListener('click',show_hide_customer_help_popup);

function scroll_to_reviews(e) {
  if (document.querySelector('#yotpo-reviews-main-widget')) {
    if (e.target.classList.contains('product-rating-stars') || e.target.closest('.product-rating-stars')) {
      scrollToElementBySelector('#yotpo-reviews-main-widget');
    }
  }
}
document.addEventListener('click',scroll_to_reviews);

document.addEventListener('DOMContentLoaded',()=>{

  let showCompare = document.querySelector('.show-compare');
  showCompare ? showCompare.closest('body').querySelector('.product-compare-float').style.display = 'grid' : '';

  /*document.querySelector('.thb-secondary-contact-and-support__dropdown-item-title--live-chat').addEventListener('click', (event) => {
    event.preventDefault();
    zE('messenger', 'open')
  })*/

  let chatElements = document.querySelectorAll(
    '.thb-secondary-contact-and-support__dropdown-item-title--live-chat, .contact-data--lch'
  )

  if (chatElements.length > 0) {
    chatElements.forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault()
        zE('messenger', 'open')
      })
    })
  }
  
  var url = new URL(window.location.href);
  if (document.querySelector('collapsible-row.accordion')) {
    var accordion = url.searchParams.get("accordion");
    var accordion_selector = '[data-target*="' + accordion + '"]';
    if (accordion !== null) {
      if (document.querySelector(accordion_selector)) {
        scrollToElementBySelector(accordion_selector);
        document.querySelector(accordion_selector + ' summary').click();
      }
    }
  }

  var show_account = url.searchParams.get("show");
  if (show_account && show_account == "account") {
    var custom_style = document.createElement('style');
    custom_style.classList.add('page-with-account-sidebar');
    custom_style.innerHTML = '#main-content accounts-hub{width:25%}#main-content .ae-content-wrapper{width:calc(75% - 1rem)}';
    custom_style.innerHTML = custom_style.innerHTML + ' @media screen and (min-width: 768px){#load-accounts-hub>#accounts-hub>#ae-holder>.widget.loadInPage{padding:0}#wrapper #main-content{flex-direction:row}}';
    document.querySelector('body').append(custom_style);
  }
  /*
  fetch('/products/nitecore-mpb21.js')
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    console.log(data);
  });
  */

  /*function waitForAccountsHub(callback) {
    const element = document.querySelector('accounts-hub');
    if (element) {
        callback(element);
        return;
    }

    const observer = new MutationObserver(function(mutations) {
        const element = document.querySelector('accounts-hub');
        if (element) {
            callback(element);
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  }

  waitForAccountsHub(function(element) {
      const account_hub_shadow = account_hub.shadowRoot;
      if (account_hub_shadow.querySelector('.main-hd') || account_hub_shadow.querySelector('.content #dashboard .heading-md')) {

      }
  });*/

  //if (document.querySelector('.current-customer-is-NOT-b2b')) {
    function waitForAccountsHubWithUrlTracking(callback) {
      let currentUrl = window.location.href;
      let domObserver = null;

      function checkElement() {
          const element = document.querySelector('accounts-hub');
          if (element) {
              callback(element);
              return true;
          }
          return false;
      }

      function setupDOMObserver() {
          if (domObserver) {
              domObserver.disconnect();
          }

          domObserver = new MutationObserver(function() {
              checkElement();
          });

          domObserver.observe(document.body, {
              childList: true,
              subtree: true
          });
      }

      if (!checkElement()) {
          setupDOMObserver();
      }

      function handleNavigation() {
          const newUrl = window.location.href;
          if (newUrl !== currentUrl) {
              currentUrl = newUrl;           
              if (!checkElement()) {
                  setupDOMObserver();
              }
          }
      }

      window.addEventListener('popstate', handleNavigation);
      window.addEventListener('hashchange', handleNavigation);

      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      history.pushState = function() {
          originalPushState.apply(this, arguments);
          handleNavigation();
      };

      history.replaceState = function() {
          originalReplaceState.apply(this, arguments);
          handleNavigation();
      };

      return function() {
          if (domObserver) domObserver.disconnect();
          window.removeEventListener('popstate', handleNavigation);
          window.removeEventListener('hashchange', handleNavigation);
          history.pushState = originalPushState;
          history.replaceState = originalReplaceState;
      };
    }

    const stopWatching = waitForAccountsHubWithUrlTracking(function(element) {
      setTimeout(() => {
        const account_hub_shadow = element.shadowRoot;
        if (!account_hub_shadow) return;
        

        function applyEnhancements() {
          if (!account_hub_shadow.querySelector('.content')) return;

          if (document.querySelector('.current-customer-is-NOT-b2b')) {
            const upgrade_account_link_URL = document.querySelector('.current-customer-is-NOT-b2b').getAttribute('data-btn-link');
            const upgrade_account_link_text = document.querySelector('.current-customer-is-NOT-b2b').innerHTML;
            const upgrade_account_link_style = document.querySelector('.current-customer-is-NOT-b2b-style');
            const upgrade_to_a_pro_account = `<a href="${upgrade_account_link_URL}" class="upgrade-account-link">${upgrade_account_link_text}</a>`;        

            if (account_hub_shadow.querySelector('.content .c-hd') && 
                !account_hub_shadow.querySelector('.content .c-hd .upgrade-account-link')) {
              account_hub_shadow.querySelector('.content .c-hd').insertAdjacentHTML('afterbegin', upgrade_to_a_pro_account);
              if (upgrade_account_link_style) {
                account_hub_shadow.querySelector('.main-hd').prepend(upgrade_account_link_style.cloneNode(true));
              }
            }

            if (document.querySelector('.fancy_title') && 
                !document.querySelector('.fancy_title .upgrade-account-link')) {
              document.querySelector('.fancy_title').insertAdjacentHTML('afterbegin', upgrade_to_a_pro_account);
            }

            if (document.querySelector('.post-title') && 
                !document.querySelector('.post-title .upgrade-account-link')) {
              document.querySelector('.post-title').insertAdjacentHTML('afterbegin', upgrade_to_a_pro_account);
            }
          }

          const orderItems = account_hub_shadow.querySelectorAll('.order-items');
          if (!orderItems.length) return;

          const ordersMeta = window.ordersMeta;
          const styleId = 'orders-extra-style';
          if (!account_hub_shadow.querySelector(`#${styleId}`)) {
            const styleElement = document.createElement('style');
            styleElement.id = styleId;
            styleElement.textContent = `
              .order-discontinued {
                position: absolute;
                font-size: 9px;
                color: #FFF;
                background: #D62727;
                padding: 3px;
                border-radius: 5px;
                opacity: .8;
                z-index: 5;
              }
              .content .c-inr .c-bx.order .order-body .order-items .o-i .order-discontinued {
                bottom: 0;
              }
              .order-find-product--button {
                position: absolute;
                bottom: 5px;
                font-size: 10px;
                background-color: #0171bb;
                color: #fff;
                text-decoration: none;
                padding: 3px;
                border-radius: 3px;
                z-index: 5;
              }
              .order-find-product--button:hover {
                opacity: .7;
              }
              .content .c-inr .c-bx.order-details .order-items .o-i {
                position: relative;
              }
              .content .c-inr .c-bx.order-details .order-items .o-i .order-find-product--button {
                right: 10px;
                bottom: 10px;
                font-size: 14px;
                padding: 10px 15px;
              }
            `;
            account_hub_shadow.appendChild(styleElement);
          }

          orderItems.forEach(orderItem => {
            const titles = orderItem.querySelectorAll('.i-tl');
            titles.forEach(title => {
              const matchedProduct = ordersMeta.find(product => product.product_title === title.textContent);
              console.log(matchedProduct)
              if (!matchedProduct) return;

              const discontinued = matchedProduct.discontinued_by_manufacturer?.trim() === "true";
              const noInventory = parseInt(matchedProduct.inventory_quantity, 10) <= 0;
              const hasReplacement = matchedProduct.replacement_sku?.trim();

              if (discontinued && !title.closest('.o-i').querySelector('.order-discontinued')) {
                title.closest('.o-i').insertAdjacentHTML(
                  'afterbegin',
                  `<span class="order-discontinued">Discontinued</span>`
                );
              }



              if (noInventory && discontinued && !title.closest('.o-i').querySelector('.order-find-product--button')) {

                if (hasReplacement) {
                  title.closest('.o-i').insertAdjacentHTML(
                    'beforeend',
                    `
                      <a href="${hasReplacement}"
                        class="order-find-product--button"
                        target="_blank">
                        Find a replacement
                      </a>
                    `
                  );
                  return;
                }

                let filter_attributes = '';

                if (matchedProduct.type?.includes("Batteries")) {
                  filter_attributes =
                    `battery_size%3A${matchedProduct.battery_size}%3Bproduct_brand%3A${matchedProduct.product_brand}%3Bbattery_chemistry%3A${matchedProduct.battery_chemistry}`;

                } else if (matchedProduct.type?.includes("Flashlights")) {
                  filter_attributes =
                    `flashlight_type%3A${matchedProduct.flashlight_type}%3Bproduct_brand%3A${matchedProduct.product_brand}`;

                } else if (matchedProduct.type?.includes("Gear")) {
                  filter_attributes =
                    `gear_type%3A${matchedProduct.gear_type}`;
                }

                title.closest('.o-i').insertAdjacentHTML(
                  'beforeend',
                  `
                    <a href="${matchedProduct.collection_url}?productListFilters=${filter_attributes}&productListPgNo=1"
                      class="order-find-product--button"
                      target="_blank">
                      Find a replacement
                    </a>
                  `
                );
              }








              /*if (noInventory && !title.closest('.o-i').querySelector('.order-find-product--button')) {

                if (hasReplacement) {
                  title.closest('.o-i').insertAdjacentHTML(
                    'beforeend',
                    `
                      <a href="${hasReplacement}" class="order-find-product--button" target="_blank">
                        Find a replacement
                      </a>
                    `
                  );
                  return;
                }

                if (!hasReplacement) {
                  let filter_attributes = '';

                  if (matchedProduct.type.includes("Batteries")) {
                    filter_attributes = `battery_size%3A${matchedProduct.battery_size}%3Bproduct_brand%3A${matchedProduct.product_brand}%3Bbattery_chemistry%3A${matchedProduct.battery_chemistry}`;
                  } else if (matchedProduct.type.includes("Flashlights")) {
                    filter_attributes = `flashlight_type%3A${matchedProduct.flashlight_type}%3Bproduct_brand%3A${matchedProduct.product_brand}`;
                  } else if (matchedProduct.type.includes("Gear")) {
                    filter_attributes = `gear_type%3A${matchedProduct.gear_type}`;
                  }

                  title.closest('.o-i').insertAdjacentHTML(
                    'beforeend',
                    `
                      <a href="${matchedProduct.collection_url}?productListFilters=${filter_attributes}&productListPgNo=1"
                        class="order-find-product--button"
                        target="_blank">
                        Find a replacement
                      </a>
                    `
                  );
                }
              }*/


              

              /*if (matchedProduct.discontinued_by_manufacturer?.trim() === "true" &&
                  !title.closest('.o-i').querySelector('.order-discontinued')) {
                title.closest('.o-i').insertAdjacentHTML('afterbegin', `<span class="order-discontinued">Discontinued</span>`);
              }*/


              /*if (parseInt(matchedProduct.inventory_quantity) <= 0 &&
                  !title.closest('.o-i').querySelector('.order-find-product--button')) {
                if (matchedProduct.replacement_sku?.trim()) {
                  title.closest('.o-i').insertAdjacentHTML('beforeend', `
                    <a href="${matchedProduct.replacement_sku}" class="order-find-product--button" target="_blank">
                      Replacement product
                    </a>
                  `);
                } else {
                  let filter_attributes = '';
                  if (matchedProduct.type.includes("Batteries")) {
                    filter_attributes = `battery_size%3A${matchedProduct.battery_size}%3Bproduct_brand%3A${matchedProduct.product_brand}%3Bbattery_chemistry%3A${matchedProduct.battery_chemistry}`;
                  } else if (matchedProduct.type.includes("Flashlights")) {
                    filter_attributes = `flashlight_type%3A${matchedProduct.flashlight_type}%3Bproduct_brand%3A${matchedProduct.product_brand}`;
                  } else if (matchedProduct.type.includes("Gear")) {
                    filter_attributes = `gear_type%3A${matchedProduct.gear_type}`;
                  }

                  title.closest('.o-i').insertAdjacentHTML('beforeend', `
                    <a href="${matchedProduct.collection_url}?productListFilters=${filter_attributes}&productListPgNo=1" class="order-find-product--button" target="_blank">
                      Find a replacement
                    </a>
                  `);
                }
              }*/


            });
          });
        }

        applyEnhancements()

        const shadowObserver = new MutationObserver(() => {
          applyEnhancements()
        })

        shadowObserver.observe(account_hub_shadow, {
          childList: true,
          subtree: true
        });
      }, 0)
    })

  //}

  /*if (document.querySelector('.current-customer-is-NOT-b2b')) {
    if (document.querySelector('accounts-hub')) {
      const account_hub = document.querySelector('accounts-hub');
      setTimeout(()=>{
        const account_hub_shadow = account_hub.shadowRoot;
        if (account_hub_shadow.querySelector('.main-hd') || account_hub_shadow.querySelector('.content #dashboard .heading-md')) {
          const upgrade_account_link_URL = document.querySelector('.current-customer-is-NOT-b2b').getAttribute('data-btn-link');
          const upgrade_account_link_text = document.querySelector('.current-customer-is-NOT-b2b').innerHTML;
          const upgrade_account_link_style = document.querySelector('.current-customer-is-NOT-b2b-style');

          const upgrade_account_link = document.createElement('a');
          upgrade_account_link.classList.add('upgrade-account-link');
          upgrade_account_link.setAttribute('href',upgrade_account_link_URL);
          upgrade_account_link.innerHTML = upgrade_account_link_text;

          if (account_hub_shadow.querySelector('.main-hd')) {
            account_hub_shadow.querySelector('#accounts-hub').append(upgrade_account_link_style);
            account_hub_shadow.querySelector('.main-hd').prepend(upgrade_account_link.cloneNode(true));
          }
          if (account_hub_shadow.querySelector('.content #dashboard .heading-md')) {
            var new_upgrade_account_link_style = document.createElement('style');
            new_upgrade_account_link_style.innerHTML = upgrade_account_link_style.innerHTML + '.upgrade-account-link{margin:0;float:right}';
            account_hub_shadow.querySelector('#accounts-everywhere').append(new_upgrade_account_link_style);
            account_hub_shadow.querySelector('.content #dashboard .heading-md').append(upgrade_account_link.cloneNode(true));
          }
        }
      },1000);
    }
  }*/

  setTimeout(()=>{
    if (document.querySelectorAll('.product-card .yotpo-widget-instance').length > 0) {
      document.querySelectorAll('.product-card .yotpo-widget-instance').forEach((rating_block)=>{
        if (rating_block.querySelector('[aria-label="0 out 5 stars rating in total 0 reviews"]')) {
          rating_block.style.display = "none"
        }
      });
    }
  },1000);

  if (document.querySelector('.table-responsive table') || document.querySelector('table#batteries')) {
    document.querySelectorAll('.table-responsive table, table#batteries').forEach((table)=>{
      if (table.hasAttribute('id') && table.getAttribute('id') == 'batteries') {
        table.querySelectorAll('td').forEach((cell)=>{
          var new_cell_content = cell.innerHTML.replaceAll('°F (','°F<br>(');
          cell.innerHTML = new_cell_content;
        });
        var table_parent = table.parentNode;
        var table_container = document.createElement('div');
        table_container.classList.add('table-responsive');
        table_parent.insertBefore(table_container, table);
        table_container.append(table);
      }
      var slider = table.closest('.table-responsive');
      var table_width = slider.querySelector('table').offsetWidth;
      if (slider.offsetWidth < table_width) {
        var top_scroll = document.createElement('div');
        top_scroll.classList.add('top-scroll');
        var top_scroll_inner = document.createElement('div');
        top_scroll_inner.style.width = table_width + "px";
        top_scroll.append(top_scroll_inner);
        var slider_parent = slider.parentNode;
        slider_parent.insertBefore(top_scroll, slider);
        slider.onscroll = function() {
          top_scroll.scrollLeft = slider.scrollLeft;
        };
        top_scroll.onscroll = function() {
          slider.scrollLeft = top_scroll.scrollLeft;
        };
      }
    });
  }

  if (document.querySelector('.dropdown-for-wholesale-section .warning-message-container') && document.querySelector('.section-collapsible-content--custom .battery-warning-block')) {
    document.querySelector('.dropdown-for-wholesale-section .warning-message-container').append(document.querySelector('.section-collapsible-content--custom .battery-warning-block'));
  }
  
});

/*fetch('https://batteryjunction.zendesk.com/api/v2/chat/agents', {
  method: 'GET',
  headers: {
    'Authorization': 'Bearer 8e76c9f3749fc010a32224c49d95c72ff1817aa17069f0a14f20161234f779e0'
  }
})
.then(response => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
})
.then(data => console.log(data))
.catch(error => console.error('Error:', error));*/

function wrapElements() {
  const accountsHub = document.querySelector('accounts-hub.ready');
  const nextElement = accountsHub?.nextElementSibling;
  
  if (accountsHub && nextElement) {
    const outerWrapper = document.createElement('div');
    outerWrapper.className = 'row';
    const innerWrapper = document.createElement('div');
    innerWrapper.className = 'account-wrapper small-12 columns';
    accountsHub.parentNode.insertBefore(outerWrapper, accountsHub);
    outerWrapper.appendChild(innerWrapper);
    innerWrapper.appendChild(accountsHub);
    innerWrapper.appendChild(nextElement);
  }
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'childList') {
      const accountsHub = document.querySelector('accounts-hub.ready');
      if (accountsHub) {
        wrapElements();
        observer.disconnect();
        break;
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

if (document.querySelector('accounts-hub.ready')) {
  wrapElements();
  observer.disconnect();
}


document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach(acc => {
    const table = acc.querySelector("table");
    if (!table) return;

    const textContent = table.textContent.replace(/\s+/g, '').trim();
    const hasLinksOrRows = table.querySelector("a, td, tr");

    if (!textContent && !hasLinksOrRows) {
      acc.classList.add("accordion--empty");
    }
  });
});